export default "__VITE_ASSET__LBaLmASO__"